import {
  List,
  Datagrid,
  EmailField,
  BooleanField,
  ReferenceField,
  ChipField,
  TextField,
  NumberField,
  DateField,
  Show,
  SimpleShowLayout,
  useNotify,
  Toolbar,
  SaveButton,
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  TopToolbar,
  CreateButton,
  ExportButton,
} from 'react-admin'

import { inviteUser } from '../dataProvider'
import { ExternalRevenueUserUrlField } from '../components'

const PROJECT_ID = '8cf65fd8'

const REVENUE_CAT_URL_URL = `https://app.revenuecat.com/customers/${PROJECT_ID}`


// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

const ListActions = ({ isCreate }) => (
  <TopToolbar>
    {isCreate && <CreateButton label="Invite User" />}
    <ExportButton />
  </TopToolbar>
)

export const UserList = ({ isCreate }) => (
  <List actions={<ListActions isCreate={isCreate} />}>
    <Datagrid bulkActionButtons={false} rowClick="show">
      <EmailField source="email" />
      <BooleanField source="isProfileSet" />
      <BooleanField source="isPremium" />
      <BooleanField source="isEmailVerified" />
      <ChipField source="role" />
      <DateField source="lastAuthenticatedAt" />
      <ChipField source="registeredWith" />
      <ExternalRevenueUserUrlField source="referenceSubscriptionId" urlPrefix={REVENUE_CAT_URL_URL} />
      <ReferenceField source="invitedBy" reference="users" />
    </Datagrid>
  </List>
)

export const UserShow = () => (
  <Show>
    <SimpleShowLayout>
      <EmailField source="email" />
      <BooleanField source="isProfileSet" />
      <BooleanField source="isPremium" />
      <DateField source="premiumUpdateAt" />
      <ExternalRevenueUserUrlField source="referenceSubscriptionId" urlPrefix={REVENUE_CAT_URL_URL} />
      <BooleanField source="isEmailVerified" />
      <ChipField source="role" />
      <BooleanField source="isMFARequired" />
      <NumberField source="acceptedTermsAndPolicyVersion" />
      <BooleanField source="isInfoUsageAcknowledged" />
      <DateField source="lastAuthenticatedAt" />
      <ChipField source="registeredWith" />
      <ReferenceField source="invitedBy" reference="users" />
    </SimpleShowLayout>
  </Show>
)

const InviteToolbar = () => {
  return (
    <Toolbar>
      <SaveButton label="Invite User" />
    </Toolbar>
  )
}

export const UserInvite = () => {
  const notify = useNotify()
  const onInvite = async (params) => {
    await inviteUser(params)

    notify('User will receive invitation on the email.')
  }

  return (
    <Create>
      <SimpleForm toolbar={<InviteToolbar />} onSubmit={onInvite}>
        <TextInput source="email" type="email" />
        <SelectInput
          source="role"
          choices={[
            { id: 'ADMIN', name: 'Admin' },
            { id: 'OBSERVER', name: 'Observer' },
            // { id: 'USER', name: 'user' },
          ]}
        />
      </SimpleForm>
    </Create>
  )
}
